import { Category } from './category'
import { Company } from './company'
import { Community } from './community'
import { DeliverySlot } from './deliverySlot'
import { RestaurantSlot } from './restaurantSlot'

export type Restaurant = {
	id: string
	title: string
	lat?: string
	lon?: string
	phone?: string | null
	email?: string | null
	isUbimeal?: boolean | null
	zipCode?: string
	city?: string
	street?: string
	houseNumber?: string
	menuVersion?: number
	// Aktive Zahlungsart der Firma; an der Tür bei DOOR, DOOR_TEST oder null, sonst online.
	paymentMethod?: string | null
	serviceFeeInCents: number
	vacation?: boolean
	isActive?: boolean
	// Leer: für alle sichtbar, sonst nur für diese Testnutzer-IDs.
	visibility?: string[]
	company?: Company | null
	communities?: Community[]
	slots?: RestaurantSlot[]
	deliverySlots?: DeliverySlot[]
	categories?: Category[]
	menuHistory?: {
		version: number
		state: string
		date: string
		preview: boolean
		sourcePdf: string | null
	}[]
	// Die Kartenstände <slug>-<YYYY-MM-DD> in api/src/restaurantData, nur für den Root.
	sourceMenus?: {
		name: string
		date: string
		hasPdf: boolean
		hasJson: boolean
		menuVersion: number | null
	}[]
	// Slug des Eintrags in der Erhebung.
	slug?: string | null
	onboardingLog?:{ step: string; at: string; by?: string | null }[]
	kioskHeartbeats?: {
		deviceId: string
		kioskVersion: number | null
		webappVersion: string | null
		lastSeenAt: string
		// Berliner Ortszeit YYYY-MM-DDTHH, nur Stunden mit mindestens einem Heartbeat.
		hours: { hour: string; count: number }[]
	}[]
}

const ADDRESS_HINT = [
	'Adressblock der Verträge',
	'Absender der Rechnung',
	'Info-Screen der App',
	'Pflicht für die Aktivierung',
]

const COORDINATE_HINT = [
	'Kartenausschnitt im Info-Screen der App',
	'Fahrstrecke und Fahrzeit zur Gemeinde',
	'Über 50 km Luftlinie wird eine Gemeinde-Verknüpfung abgelehnt',
	'Nicht für Liefergebiete — die kommen von den Gemeinde-Koordinaten',
]

// Label und Erklärung jedes Restaurantfeldes stehen nur hier — Gegenstück zu COMPANY_FIELDS.
export const RESTAURANT_FIELDS: { key: keyof Restaurant; label: string; hint: string[] }[] = [
	{
		key: 'title',
		label: 'Titel',
		hint: [
			'Anzeigename in der App',
			'Betreff und Anrede aller Mails',
			'Verträge, Rechnung, Bestellübersicht',
			'Beschreibung der Stripe-Zahlung',
		],
	},
	{ key: 'street', label: 'Straße', hint: ADDRESS_HINT },
	{ key: 'houseNumber', label: 'Hausnummer', hint: ADDRESS_HINT },
	{ key: 'zipCode', label: 'PLZ', hint: ADDRESS_HINT },
	{
		key: 'city',
		label: 'Stadt',
		hint: [
			'Adressblock der Verträge',
			'Absender der Rechnung',
			'Info-Screen der App',
			'Als einziges Adressfeld keine Pflicht für die Aktivierung',
		],
	},
	{ key: 'lat', label: 'Latitude', hint: COORDINATE_HINT },
	{ key: 'lon', label: 'Longitude', hint: COORDINATE_HINT },
	{
		key: 'phone',
		label: 'Telefon',
		hint: [
			'Anruf-Link in der App',
			'Steht auf der Rechnung',
			'Pflicht für die Aktivierung',
		],
	},
	{
		key: 'email',
		label: 'E-Mail',
		hint: [
			'Empfänger der Bestellbenachrichtigungen',
			'Absenderkontakt auf der Kundenrechnung',
			'Mail-Link in der App',
			'Pflicht für die Aktivierung',
		],
	},
]
